import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import {
  PortalServiceDetailsCategoryResponse,
} from '../../models/portal/GetAllServicesDetailResponse';
import { PortalServiceDetailsAllServicesDetailResponse } from "../../models/portal/PortalServiceDetailsAllServicesDetailResponse";
import { PortalServiceDetailsMapperService } from './portal-service-details-mapper.service';

@Injectable({
  providedIn: 'root',
})
export class GetAllServicesDetailService {
  private GET_CONTENT_LIST_URI =
    environment.gateway + environment.websiteUrl + 'GetContentList';

  private REST_API_SERVER_GET_CATEGORIES_NEW =
    environment.gateway +
    environment.websiteUrl +
    'GetCategoriesListing?languageId={languageId}&parentId={parentId}&orderBy={orderBy}';

  constructor(
    private httpClient: HttpClient,
    private serviceDetailsMapper: PortalServiceDetailsMapperService
  ) {}

  public getContentList(
    lang: string
  ): Observable<PortalServiceDetailsAllServicesDetailResponse> {
    const languageId = this.serviceDetailsMapper.resolveLanguageId(lang);

    return this.httpClient
      .post<PortalServiceDetailsAllServicesDetailResponse>(
        this.GET_CONTENT_LIST_URI,
        {
          languageId: languageId,
          contentTypeId: 1062,
          pageSize: 500,
          pageIndex: 1,
          loadMainAttributes: true,
          attributes: [
            'attr.digitalservice',
            'attr.requiredDocuments',
            'attr.conditionsAndRequirements',
            'attr.startServiceLink',
            'attr.subcategory',
            'attr.serviceCode',
            'attr.numberOfUsers',
            'attr.numberOfApplications',
            'attr.sDGGoals',
            'attr.isMostUsed',
            'attr.serviceProcess',
            'attr.documents',
            'attr.relatedServices',
            'attr.serviceChannels',
            'attr.audience',
            'attr.fees',
            'attr.serviceTime',
            'attr.faq',
            'attr.notes',
          ],
        }
      )
      .pipe(catchError(this.handleError));
  }

  public getCategoriesListing(
    parentId: string,
    lang: string
  ): Observable<PortalServiceDetailsCategoryResponse> {
    const languageId = this.serviceDetailsMapper.resolveLanguageId(lang);

    return this.httpClient
      .get<PortalServiceDetailsCategoryResponse>(
        this.REST_API_SERVER_GET_CATEGORIES_NEW.replace('{parentId}', parentId)
          .replace('{languageId}', languageId.toString())
          .replace('{orderBy}', 'title')
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error(
        '[GetAllServicesDetail] Client Side Error',
        errorResponse.error.message
      );
    } else {
      console.error(
        '[GetAllServicesDetail] Server Side Error',
        errorResponse.error.message
      );
    }

    return throwError(
      'There is a problem with the service. we are notified & working on it. please try again later'
    );
  }
}
